import Lottie from 'lottie-react';
import type { ReactionKind } from '@durak/shared';
import hi from '../assets/reactions/hi.json';
import bye from '../assets/reactions/bye.json';
import cry from '../assets/reactions/cry.json';
import laugh from '../assets/reactions/laugh.json';
import awesome from '../assets/reactions/awesome.json';
import gg from '../assets/reactions/gg.json';

const DATA: Record<ReactionKind, unknown> = {
  hi,
  bye,
  cry,
  laugh,
  awesome,
  gg,
};

/** Animated emoji art — Google Noto Animated Emoji Lottie. */
export function ReactionArt({ kind, size = 56 }: { kind: ReactionKind; size?: number }) {
  return (
    <Lottie
      animationData={DATA[kind]}
      loop
      autoplay
      rendererSettings={{ preserveAspectRatio: 'xMidYMid meet' }}
      style={{ width: size, height: size }}
    />
  );
}
